import React from 'react';
import { SvgIcon } from './utils/SvgIcon.js';
import type { SvgIconT } from './utils/react-desc-prop-types.js';

const Documents2 = (props: SvgIconT.Props) => (
  <SvgIcon width={24} height={24} {...props} viewBox="0 0 24 24">
    <g>
      <path d="M19,21H5V7h8.8l1-1H5V4h11.8l1-1H5C4.5,3,4,3.5,4,4v2v1v14c0,0.5,0.5,1,1,1h14c0.5,0,1-0.5,1-1V9.2l-1,1V21z" />
      <rect x="10" y="18" width="7" height="1" />
      <rect x="7" y="15" width="10" height="1" />
      <path
        d="M23.4,1.6c-0.3-0.3-0.7-0.5-1-0.5c-0.1,0-0.3,0-0.4,0c-0.5,0-1,0.2-1.4,0.6l-0.7,0.7L19.2,3l0,0l-1,1l-2,2l-1,1l-1.7,1.7
			l-1.4,4.2l4.2-1.4L19,8.8l1-1l2-2l0.7-0.7l0.7-0.7C24.2,3.6,24.2,2.4,23.4,1.6z M20,6.4L19.4,7L19,7.4l-3.2,3.2l-2.1,0.7l0.7-2.1
			L16.6,7l1-1L19,4.6l0.9-0.9L20,3.8l1.3,1.3L20,6.4z M22.7,3.7L22,4.4L20.6,3l0.7-0.7C21.5,2.1,21.7,2,22,2c0.1,0,0.3,0,0.4,0.1
			c0.1,0,0.2,0.1,0.3,0.2C22.9,2.5,23,2.7,23,3C23,3.3,22.9,3.5,22.7,3.7z"
      />
    </g>
  </SvgIcon>
);

export default Documents2;
